var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1463 11.7647H18.2309C16.1102 11.7647 14.4 13.4756 14.4 15.5972V20H20.1691C22.2898 20 24 18.2891 24 16.1675V15.62C24 13.4756 22.267 11.7647 20.1463 11.7647Z",
    fill: "#141938"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 10.5882C20.2569 10.5882 21.6 9.27143 21.6 7.64706C21.6 6.02269 20.2569 4.70588 18.6 4.70588C16.9431 4.70588 15.6 6.02269 15.6 7.64706C15.6 9.27143 16.9431 10.5882 18.6 10.5882Z",
    fill: "#141938"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 8.23529C10.1196 8.23529 12 6.39176 12 4.11765C12 1.84353 10.1196 0 7.8 0C5.4804 0 3.6 1.84353 3.6 4.11765C3.6 6.39176 5.4804 8.23529 7.8 8.23529Z",
    fill: "#141938"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 11.3483C13.6788 10.8789 12.8134 10.5882 11.8758 10.5882H4.32721C1.94725 10.5882 0 12.399 0 14.6123V16.2442C0 18.3233 1.803 20 4.03873 20H12.1402V15.6853C12.1402 13.9416 13.0297 12.3767 14.4 11.3483Z",
    fill: "#141938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoFamily);
export default __webpack_public_path__ + "static/media/icono-family.7db3aed4ddf7b09267cf0cc0fca07a73.svg";
export { ForwardRef as ReactComponent };